import { useState, useEffect } from "react";
import { studiesService } from "../service";
import { toast } from "react-toastify";
import {
  EditorState,
  convertToRaw,
  ContentState,
} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";

export const useEditStudy = (study, onClose) => {
  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    abstract: "",
    protocol: "",
  });

  const [editorAbstract, setEditorAbstract] = useState(EditorState.createEmpty());
  const [editorProtocol, setEditorProtocol] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (!study) return;
    setFormData(study);

    const loadEditor = (html, setEditor) => {
      if (html) {
        const { contentBlocks, entityMap } = htmlToDraft(html);
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        setEditor(EditorState.createWithContent(contentState));
      }
    };

    loadEditor(study.abstract, setEditorAbstract);
    loadEditor(study.protocol, setEditorProtocol);
  }, [study]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedData = {
      ...formData,
      abstract: draftToHtml(convertToRaw(editorAbstract.getCurrentContent())),
      protocol: draftToHtml(convertToRaw(editorProtocol.getCurrentContent())),
    };

    try {
      await studiesService.update(study.id, updatedData);
      toast.success("Étude mise à jour avec succès.");
      onClose(true);
    } catch (err) {
      console.error("Erreur lors de la mise à jour :", err);
      toast.error("Échec de la mise à jour de l'étude.");
    }
  };

  return {
    formData,
    editorAbstract,
    editorProtocol,
    setEditorAbstract,
    setEditorProtocol,
    handleChange,
    handleSubmit,
  };
};
